module.exports = "<div *ngIf=\"subTotal\" class=\"container panel panel-default\">\n  <div class=\"panel-heading\">Payment with Stripe coming soon!</div>\n  <div class=\"panel-body checkout_body\">\n    <h5>Delivery address:\n      <br>\n      <span class=\"itemDetails\">250 Del Medio Ave, apt. 307\n        <br>Mountain View, CA 97225</span>\n    </h5>\n    <h2 *ngIf=\"subTotal\">Total: {{subTotal}}</h2>\n    <img src=\"https://www.paypalobjects.com/webstatic/en_US/i/buttons/checkout-logo-large.png\" alt=\"Check out with PayPal\" />\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/functional_components/cart/checkout/checkout.component.html
// module id = 401
// module chunks = 1